<div id="todo" class="page-layout simple fullwidth docs left-sidebar">
    <div class="content" [ngClass]="this.view" style="max-width: 100%;">

        <div fxLayout="column" fxLayoutAlign="start"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" style="padding-bottom: 10px;">
            <div class="widget p-8" fxFlex="100">
                <div class="fuse-card content-card auto-width">
                    <div class="p-16" style="padding-bottom: 0 !important;" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="h1 pr-16" *ngIf="trainer">
                            {{'Trainer'|translate}} {{trainer.firstName}} {{trainer.lastName}}
                        </div>
                        <div class="h1 pr-16" style="padding-bottom: 16px; !important;" *ngIf="!trainer && !loadingTrainer && !trainerNotFound">
                            Zeskanuj swoją kartę aby rozpocząć rejestrację uczestników
                        </div>

                        <div class="h1 pr-16 warning alert" *ngIf="!trainer && !loadingTrainer && trainerNotFound">
                            <mat-icon>warning</mat-icon> Nie odnaleziono danych trenera. Zeskanuj ponownie swoją kartą lub zgłoś się do punktu obsługi.
                        </div>

                        <div class="h1 pr-16" style="padding-bottom: 16px; !important;" *ngIf="!trainer && loadingTrainer">
                            <div class="spinner-wrapper">
                                <mat-spinner diameter="20" mode="indeterminate"></mat-spinner> Wczytuję dane...
                            </div>
                        </div>
                    </div>

                    <div class="p-16" style="padding-top: 0 !important;" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="trainer && !selectedService">
                        <div>
                            <h3>Wybierz rodzaj treningu/zabiegu</h3>
                            <button mat-raised-button color="accent" (click)="selectService(service)" *ngFor="let service of trainer.services">{{service.name}}</button><br/>
                        </div>
                    </div>

                    <div class="p-16" *ngIf="trainer && selectedService">
                        <div fxLayout="row" fxLayoutAlign="start">
                            <h3><b>Trening/Zabieg:</b> {{selectedService.name}}</h3>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start">
                            <h4><b>Rozpocznij skanowanie kart uczestników - uwaga zeskanowanie karty i potwierdzenie oznacza zmniejszenie ilości treningów/zabiegów na karcie uczestnika</b></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="trainer">
            <div class="card p-8" *ngIf="loading">
                <!-- PREVIEW -->
                <div class="card-preview" fxFlex="100">
                    <div class="fuse-card" fxFlex="100">
                        <div class="pl-16 pr-16 pt-0 line-height-1.75">
                            <h2>
                                <div class="spinner-wrapper">
                                    <mat-spinner diameter="20" mode="indeterminate"></mat-spinner> Wczytuję dane klienta...
                                </div>
                            </h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cards" style="width: 100%;" fxLayout="row wrap" fxLayout.xs="column wrap" *ngIf="participants.length>0">
                <div class="card p-8" *ngFor="let participant of participants">
                    <!-- PREVIEW -->
                    <div class="card-preview" fxFlex="100">
                        <div class="fuse-card" fxFlex="100">
                            <div class="pl-16 pr-16 pt-0 line-height-1.75">
                                <h2>{{participant.firstName}} {{participant.lastName}}</h2>
                                <h3>Numer karty: {{participant.cardNumber}}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
